import { CurrencyPipe } from '@angular/common';

export function formatCurrencyForHelper(
  value: number | string,
  currencyPipe: CurrencyPipe,
  options: any,
): string | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  /*
   * If the currencyCode argument passed to this helper is a skeleton placeholder (i.e. an HTML string containing 'skeleton_'), we should bypass formatting and directly return the skeleton HTML as-is.
   * This avoids breaking the HTML structure — for example,
   * Without this, a class like 'h6' could incorrectly become 'h 6'.
    Example:
     currencyCode = '<span class="h6 skeleton_item">...</span>'
     return it directly instead of formatting.
   */
  if (typeof options?.hash?.currencyCode === 'string' && options?.hash?.currencyCode?.includes('skeleton_')) {
    return options.hash.currencyCode.toString();
  }

  const isSpaceRequired =
    options?.hash?.isSpaceRequired === 'true' || options?.hash?.isSpaceRequired === true;

  let numberValue: number;
  if (typeof value === 'number') {
    numberValue = value;
  } else {
    if (typeof value !== 'string') {
      return null;
    }

    // Replace commas and convert the input to a number
    const sanitizedValue = value.toString().replaceAll(',', '');
    numberValue = Number.parseFloat(sanitizedValue);
  }

  if (Number.isNaN(numberValue)) {
    return null;
  }

  return (
    currencyPipe
      .transform(
        numberValue,
        options.hash.currencyCode,
        options.hash.display,
        options.hash.digitsInfo,
        options.hash.locale,
      )
      ?.replace(/([^\d.,])(\d)/, isSpaceRequired ? '$1 $2' : '$1$2') ?? null
  );
}

/*
 * Coerces a numeric value (number or numeric string with optional commas) to a
 * plain string representation. Returns `null` for null/undefined/empty/non-numeric
 * input. Used by helpers that need plain number output (no currency formatting).
 */
export function toPlainNumberString(value: number | string): string | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  let numberValue: number;
  if (typeof value === 'number') {
    numberValue = value;
  } else if (typeof value === 'string') {
    numberValue = Number.parseFloat(value.replaceAll(',', ''));
  } else {
    return null;
  }

  if (Number.isNaN(numberValue)) {
    return null;
  }

  return numberValue.toString();
}
